import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HttpHelper from '../service/httpService';

const FooterSection = () => {

    const [currentYear, setCurrentYear] = useState();
    const [menus, setMenus] = useState({});

    const getInfo = (item) => {
        let data = localStorage.getItem('WebsiteSetting');
        if (data !== null) {
            let info = JSON.parse(data);
            let val = info.filter((elem) => elem.name === item);
            return val != null && val.length > 0 ? val[0].value : '';
        }
        else {
            HttpHelper.get("website/GetSettingData").then((response) => {
                localStorage.setItem('WebsiteSetting', JSON.stringify(response.data))
                let val = response.data.filter((elem) => elem.name === item);
                val != null && val.length > 0 ? val[0].value : '';
            })
        }
    }

    const getMenuData = async () => {
        await HttpHelper.get("website/GetFooterMenuItems").then((response) => {
            if (response.status === 200) {
                setMenus(response.data);
            }
        })
    }

    useEffect(() => {
        const CurrentDate = new Date();
        let CurrentYear = CurrentDate.getFullYear();
        setCurrentYear(CurrentYear);

        if (localStorage.getItem('MenuItems')) {
            setMenus(JSON.parse(localStorage.getItem('MenuItems')));
        } else {
            getMenuData();
        }

    }, []);

    return (
        <>
            <div className="footer-section section" style={{ backgroundColor: `#122e14` }} data-bg-color="#122e14">
                <div className="container">

                    {/* <!-- Footer Top Widgets Start --> */}
                    <div className="row mb-lg-10 mb-md-10 mb-6">

                        {/* <!-- Footer Widget Start --> */}
                        <div className="col-md-2 col-12 mb-6 d-flex justify-content-center">
                            <div className="footer-widget">
                                <div className="footer-logo">
                                    <Link to='/'><img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} alt="No image found" /></Link>
                                </div>

                            </div>
                        </div>

                        <div className="col-md-4 col-12 mb-6 pl-lg-5">
                            <div className="footer-widget">
                                <div className="col-md-12">
                                    <h4 className="footer-widget-title">Address</h4>
                                </div>
                                <div className="footer-widget-content">
                                    <div className="content">
                                        <div>
                                            {getInfo('Address1')}
                                            <br />
                                            {getInfo('Address2')}
                                            <br />
                                            <br />
                                            Phone: {getInfo('Phone1')}
                                            <br />
                                            Fax: {getInfo('Fax1')}
                                            <br />
                                        </div>
                                    </div>
                                    <div className="footer-social-inline d-none">
                                        <a href='/' target="_blank" ><i className="fab fa-facebook-square"></i></a>
                                        <a href="/" target="_blank"><i className="fab fa-linkedin-in"></i></a>
                                        <a href="/" target="_blank"><i className="fab fa-twitter-square"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Footer Widget Start --> */}
                        < div className="col-md-6 mb-6 col-12 ps-md-4" >
                            <div className="footer-widget">
                                <div className="col-md-12">
                                    <h4 className="footer-widget-title">Quick Links</h4>
                                </div>
                                <div className="footer-widget-content">
                                    <div className="content col-md-12 d-flex flex-wrap">
                                        {
                                            menus && menus.length > 0 ? menus.map((menu, index) => {
                                                if (menu.isActive == true) {
                                                    return (
                                                        menu.externalLink === null || menu.externalLink === '' ?
                                                            <div key={index} className=" col-lg-4 col-6" >
                                                                <Link to={menu.page ? '/page?slug=' + menu.page.slug : '/'} > {menu.title} </Link>
                                                            </div>
                                                            :
                                                            <div className="col-lg-4 col-6">
                                                                <Link to={menu.externalLink}> {menu.title} </Link>
                                                            </div>
                                                    )
                                                }
                                            }) : ""
                                        }
                                        <div className="col-md-4 col-6">
                                            <Link to='https://trailbossinc.hua.hrsmart.com/hr/ats/JobSearch/viewAll' target="_blank"><span className="menu-text">Careers</span></Link>
                                        </div>
                                        <div className=" col-md-4 col-6">
                                            <Link to={setting.advantageWebUrl}><span className="menu-text">Employee Resources</span></Link>
                                        </div>
                                        {/*<div className="col-md-4 col-6">*/}
                                        {/*    <Link to="/dashboard">Login</Link>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <p className="copyright">© {currentYear} Trailboss Enterprises, Inc.  All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default memo(FooterSection);